module.exports = __webpack_public_path__ + "img/t8.c674e64c.png";